import e, { Fragment as t, memo as a, createElement as i, useRef as r, useMemo as n, useEffect as s, useLayoutEffect as o } from "react";
import l from "camelcase";
import * as d from "prop-types";
import h from "prop-types";
function u() {
  return u = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var i in a) Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
    }
    return e;
  }, u.apply(this, arguments);
}
function c(e, t) {
  if (null == e) return {};
  var a,
    i,
    r = {},
    n = Object.keys(e);
  for (i = 0; i < n.length; i++) t.indexOf(a = n[i]) >= 0 || (r[a] = e[a]);
  return r;
}
const g = [.25, .5, 1, 2],
  p = [750, 1080, 1366, 1920],
  m = [320, 654, 768, 1024, 1366, 1600, 1920, 2048, 2560, 3440, 3840, 4096],
  f = e => console.warn(e),
  w = (e, t) => e - t,
  y = e => e.map(e => "".concat(e.src, " ").concat(e.width, "w")).join(",\n");
function b(e) {
  const t = e.lastIndexOf(".");
  if (-1 !== t) {
    const a = e.slice(t + 1);
    if ("jpeg" === a) return "jpg";
    if (3 === a.length || 4 === a.length) return a;
  }
}
function v(e) {
  let {
    layout: t = "constrained",
    width: a,
    height: i,
    sourceMetadata: r,
    breakpoints: n,
    aspectRatio: s,
    formats: o = ["auto", "webp"]
  } = e;
  return o = o.map(e => e.toLowerCase()), t = l(t), a && i ? u({}, e, {
    formats: o,
    layout: t,
    aspectRatio: a / i
  }) : (r.width && r.height && !s && (s = r.width / r.height), "fullWidth" === t ? (a = a || r.width || n[n.length - 1], i = i || Math.round(a / (s || 1.3333333333333333))) : (a || (a = i && s ? i * s : r.width ? r.width : i ? Math.round(i / 1.3333333333333333) : 800), s && !i ? i = Math.round(a / s) : s || (s = a / i)), u({}, e, {
    width: a,
    height: i,
    aspectRatio: s,
    layout: t,
    formats: o
  }));
}
function E(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var a;
  e = v(e);
  const {
    generateImageSource: i,
    filename: r,
    aspectRatio: n
  } = e;
  return null == (a = i(r, t, Math.round(t / n), e.sourceMetadata.format || "jpg", e.fit, e.options)) ? void 0 : a.src;
}
function M(e) {
  e = v(e);
  let {
    pluginName: t,
    sourceMetadata: a,
    generateImageSource: i,
    layout: r,
    fit: n,
    options: s,
    width: o,
    height: l,
    filename: d,
    reporter: h = {
      warn: f
    },
    backgroundColor: c,
    placeholderURL: m
  } = e;
  if (t || h.warn('[gatsby-plugin-image] "generateImageData" was not passed a plugin name'), "function" != typeof i) throw new Error("generateImageSource must be a function");
  var w;
  a && (a.width || a.height) ? a.format || (a.format = b(d)) : a = {
    width: o,
    height: l,
    format: (null == (w = a) ? void 0 : w.format) || b(d) || "auto"
  };
  const E = new Set(e.formats);
  (0 === E.size || E.has("auto") || E.has("")) && (E.delete("auto"), E.delete(""), E.add(a.format)), E.has("jpg") && E.has("png") && (h.warn("[".concat(t, "] Specifying both 'jpg' and 'png' formats is not supported. Using 'auto' instead")), E.delete("jpg" === a.format ? "png" : "jpg"));
  const M = function (e) {
      const {
          width: t,
          height: a,
          filename: i,
          layout: r = "constrained",
          sourceMetadata: n,
          reporter: s = {
            warn: f
          },
          breakpoints: o = p
        } = e,
        l = Object.entries({
          width: t,
          height: a
        }).filter(_ref => {
          let [e, t] = _ref;
          return "number" == typeof t && t < 1;
        });
      if (l.length) throw new Error("Specified dimensions for images must be positive numbers (> 0). Problem dimensions you have are ".concat(l.map(e => e.join(": ")).join(", ")));
      return "fixed" === r ? function (_ref2) {
        let {
          filename: e,
          sourceMetadata: t,
          width: a,
          height: i,
          fit: r = "cover",
          outputPixelDensities: n = g,
          reporter: s = {
            warn: f
          }
        } = _ref2;
        let o = t.width / t.height;
        const l = k(n);
        if (a && i) {
          const e = $(t, {
            width: a,
            height: i,
            fit: r
          });
          a = e.width, i = e.height, o = e.aspectRatio;
        }
        a ? i || (i = Math.round(a / o)) : a = i ? Math.round(i * o) : 800;
        const d = a;
        if (t.width < a || t.height < i) {
          const r = t.width < a ? "width" : "height";
          s.warn("\nThe requested ".concat(r, " \"").concat("width" === r ? a : i, "px\" for the image ").concat(e, " was larger than the actual image ").concat(r, " of ").concat(t[r], "px. If possible, replace the current image with a larger one.")), "width" === r ? (a = t.width, i = Math.round(a / o)) : a = (i = t.height) * o;
        }
        return {
          sizes: l.filter(e => e >= 1).map(e => Math.round(e * a)).filter(e => e <= t.width),
          aspectRatio: o,
          presentationWidth: d,
          presentationHeight: Math.round(d / o),
          unscaledWidth: a
        };
      }(e) : "constrained" === r ? S(e) : "fullWidth" === r ? S(u({
        breakpoints: o
      }, e)) : (s.warn("No valid layout was provided for the image at ".concat(i, ". Valid image layouts are fixed, fullWidth, and constrained. Found ").concat(r)), {
        sizes: [n.width],
        presentationWidth: n.width,
        presentationHeight: n.height,
        aspectRatio: n.width / n.height,
        unscaledWidth: n.width
      });
    }(u({}, e, {
      sourceMetadata: a
    })),
    I = {
      sources: []
    };
  let x = e.sizes;
  x || (x = ((e, t) => {
    switch (t) {
      case "constrained":
        return "(min-width: ".concat(e, "px) ").concat(e, "px, 100vw");
      case "fixed":
        return "".concat(e, "px");
      case "fullWidth":
        return "100vw";
      default:
        return;
    }
  })(M.presentationWidth, r)), E.forEach(e => {
    const a = M.sizes.map(a => {
      const r = i(d, a, Math.round(a / M.aspectRatio), e, n, s);
      if (null != r && r.width && r.height && r.src && r.format) return r;
      h.warn("[".concat(t, "] The resolver for image ").concat(d, " returned an invalid value."));
    }).filter(Boolean);
    if ("jpg" === e || "png" === e || "auto" === e) {
      const e = a.find(e => e.width === M.unscaledWidth) || a[0];
      e && (I.fallback = {
        src: e.src,
        srcSet: y(a),
        sizes: x
      });
    } else {
      var r;
      null == (r = I.sources) || r.push({
        srcSet: y(a),
        sizes: x,
        type: "image/".concat(e)
      });
    }
  });
  const N = {
    images: I,
    layout: r,
    backgroundColor: c
  };
  switch (m && (N.placeholder = {
    fallback: m
  }), r) {
    case "fixed":
      N.width = M.presentationWidth, N.height = M.presentationHeight;
      break;
    case "fullWidth":
      N.width = 1, N.height = 1 / M.aspectRatio;
      break;
    case "constrained":
      N.width = e.width || M.presentationWidth || 1, N.height = (N.width || 1) / M.aspectRatio;
  }
  return N;
}
const k = e => Array.from(new Set([1, ...e])).sort(w);
function S(_ref3) {
  let {
    sourceMetadata: e,
    width: t,
    height: a,
    fit: i = "cover",
    outputPixelDensities: r = g,
    breakpoints: n,
    layout: s
  } = _ref3;
  let o,
    l = e.width / e.height;
  const d = k(r);
  if (t && a) {
    const r = $(e, {
      width: t,
      height: a,
      fit: i
    });
    t = r.width, a = r.height, l = r.aspectRatio;
  }
  t = t && Math.min(t, e.width), a = a && Math.min(a, e.height), t || a || (a = (t = Math.min(800, e.width)) / l), t || (t = a * l);
  const h = t;
  return (e.width < t || e.height < a) && (t = e.width, a = e.height), t = Math.round(t), (null == n ? void 0 : n.length) > 0 ? (o = n.filter(t => t <= e.width), o.length < n.length && !o.includes(e.width) && o.push(e.width)) : (o = d.map(e => Math.round(e * t)), o = o.filter(t => t <= e.width)), "constrained" !== s || o.includes(t) || o.push(t), o = o.sort(w), {
    sizes: o,
    aspectRatio: l,
    presentationWidth: h,
    presentationHeight: Math.round(h / l),
    unscaledWidth: t
  };
}
function $(e, t) {
  const a = e.width / e.height;
  let i = t.width,
    r = t.height;
  switch (t.fit) {
    case "fill":
      i = t.width ? t.width : e.width, r = t.height ? t.height : e.height;
      break;
    case "inside":
      {
        const e = t.width ? t.width : Number.MAX_SAFE_INTEGER,
          n = t.height ? t.height : Number.MAX_SAFE_INTEGER;
        i = Math.min(e, Math.round(n * a)), r = Math.min(n, Math.round(e / a));
        break;
      }
    case "outside":
      {
        const e = t.width ? t.width : 0,
          n = t.height ? t.height : 0;
        i = Math.max(e, Math.round(n * a)), r = Math.max(n, Math.round(e / a));
        break;
      }
    default:
      t.width && !t.height && (i = t.width, r = Math.round(t.width / a)), t.height && !t.width && (i = Math.round(t.height * a), r = t.height);
  }
  return {
    width: i,
    height: r,
    aspectRatio: i / r
  };
}
const I = ["baseUrl", "urlBuilder", "sourceWidth", "sourceHeight", "pluginName", "formats", "breakpoints", "options"],
  x = ["images", "placeholder"],
  N = () => "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
function L() {
  return "undefined" != typeof GATSBY___IMAGE && GATSBY___IMAGE;
}
const W = e => {
    var t;
    return (e => {
      var t, a;
      return Boolean(null == e || null == (t = e.images) || null == (a = t.fallback) ? void 0 : a.src);
    })(e) ? e : (e => Boolean(null == e ? void 0 : e.gatsbyImageData))(e) ? e.gatsbyImageData : (e => Boolean(null == e ? void 0 : e.gatsbyImage))(e) ? e.gatsbyImage : null == e || null == (t = e.childImageSharp) ? void 0 : t.gatsbyImageData;
  },
  T = e => {
    var t, a, i;
    return null == (t = W(e)) || null == (a = t.images) || null == (i = a.fallback) ? void 0 : i.src;
  },
  R = e => {
    var t, a, i;
    return null == (t = W(e)) || null == (a = t.images) || null == (i = a.fallback) ? void 0 : i.srcSet;
  };
function _(e) {
  var t;
  let {
      baseUrl: a,
      urlBuilder: i,
      sourceWidth: r,
      sourceHeight: n,
      pluginName: s = "getImageData",
      formats: o = ["auto"],
      breakpoints: l,
      options: d
    } = e,
    h = c(e, I);
  return null != (t = l) && t.length || "fullWidth" !== h.layout && "FULL_WIDTH" !== h.layout || (l = m), M(u({}, h, {
    pluginName: s,
    generateImageSource: (e, t, a, r) => ({
      width: t,
      height: a,
      format: r,
      src: i({
        baseUrl: e,
        width: t,
        height: a,
        options: d,
        format: r
      })
    }),
    filename: a,
    formats: o,
    breakpoints: l,
    sourceMetadata: {
      width: r,
      height: n,
      format: "auto"
    }
  }));
}
function j(e, t, a, i) {
  let r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return L() || (r = u({
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    transform: "translateZ(0)",
    transition: "opacity 250ms linear",
    width: "100%",
    willChange: "opacity"
  }, r)), u({}, a, {
    loading: i,
    shouldLoad: e,
    "data-main-image": "",
    style: u({}, r, {
      opacity: t ? 1 : 0
    })
  });
}
function O(e, t, a, i, r, n, s, o) {
  const l = {};
  n && (l.backgroundColor = n, "fixed" === a ? (l.width = i, l.height = r, l.backgroundColor = n, l.position = "relative") : ("constrained" === a || "fullWidth" === a) && (l.position = "absolute", l.top = 0, l.left = 0, l.bottom = 0, l.right = 0)), s && (l.objectFit = s), o && (l.objectPosition = o);
  const d = u({}, e, {
    "aria-hidden": !0,
    "data-placeholder-image": "",
    style: u({
      opacity: t ? 0 : 1,
      transition: "opacity 500ms linear"
    }, l)
  });
  return L() || (d.style = {
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%"
  }), d;
}
function C(e, t) {
  const {
      images: a,
      placeholder: i
    } = e,
    r = u({}, c(e, x), {
      images: u({}, a, {
        sources: []
      }),
      placeholder: i && u({}, i, {
        sources: []
      })
    });
  var n;
  return t.forEach(_ref4 => {
    let {
      media: t,
      image: a
    } = _ref4;
    t ? (a.layout !== e.layout && "development" === process.env.NODE_ENV && console.warn("[gatsby-plugin-image] Mismatched image layout: expected \"".concat(e.layout, "\" but received \"").concat(a.layout, "\". All art-directed images use the same layout as the default image")), r.images.sources.push(...a.images.sources.map(e => u({}, e, {
      media: t
    })), {
      media: t,
      srcSet: a.images.fallback.srcSet
    }), r.placeholder && r.placeholder.sources.push({
      media: t,
      srcSet: a.placeholder.fallback
    })) : "development" === process.env.NODE_ENV && console.warn("[gatsby-plugin-image] All art-directed images passed to must have a value set for `media`. Skipping.");
  }), r.images.sources.push(...a.sources), null != i && i.sources && (null == (n = r.placeholder) || n.sources.push(...i.sources)), r;
}
const z = ["children"],
  D = function (_ref5) {
    let {
      layout: t,
      width: a,
      height: i
    } = _ref5;
    return "fullWidth" === t ? e.createElement("div", {
      "aria-hidden": !0,
      style: {
        paddingTop: i / a * 100 + "%"
      }
    }) : "constrained" === t ? e.createElement("div", {
      style: {
        maxWidth: a,
        display: "block"
      }
    }, e.createElement("img", {
      alt: "",
      role: "presentation",
      "aria-hidden": "true",
      src: "data:image/svg+xml;charset=utf-8,%3Csvg height='".concat(i, "' width='").concat(a, "' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3C/svg%3E"),
      style: {
        maxWidth: "100%",
        display: "block",
        position: "static"
      }
    })) : null;
  },
  A = function (a) {
    let {
        children: i
      } = a,
      r = c(a, z);
    return e.createElement(t, null, e.createElement(D, u({}, r)), i, null);
  },
  q = ["src", "srcSet", "loading", "alt", "shouldLoad"],
  P = ["fallback", "sources", "shouldLoad"],
  H = function (t) {
    let {
        src: a,
        srcSet: i,
        loading: r,
        alt: n = "",
        shouldLoad: s
      } = t,
      o = c(t, q);
    return e.createElement("img", u({}, o, {
      decoding: "async",
      loading: r,
      src: s ? a : void 0,
      "data-src": s ? void 0 : a,
      srcSet: s ? i : void 0,
      "data-srcset": s ? void 0 : i,
      alt: n
    }));
  },
  G = function (t) {
    let {
        fallback: a,
        sources: i = [],
        shouldLoad: r = !0
      } = t,
      n = c(t, P);
    const s = n.sizes || (null == a ? void 0 : a.sizes),
      o = e.createElement(H, u({}, n, a, {
        sizes: s,
        shouldLoad: r
      }));
    return i.length ? e.createElement("picture", null, i.map(_ref6 => {
      let {
        media: t,
        srcSet: a,
        type: i
      } = _ref6;
      return e.createElement("source", {
        key: "".concat(t, "-").concat(i, "-").concat(a),
        type: i,
        media: t,
        srcSet: r ? a : void 0,
        "data-srcset": r ? void 0 : a,
        sizes: s
      });
    }), o) : o;
  };
var V;
H.propTypes = {
  src: d.string.isRequired,
  alt: d.string.isRequired,
  sizes: d.string,
  srcSet: d.string,
  shouldLoad: d.bool
}, G.displayName = "Picture", G.propTypes = {
  alt: d.string.isRequired,
  shouldLoad: d.bool,
  fallback: d.exact({
    src: d.string.isRequired,
    srcSet: d.string,
    sizes: d.string
  }),
  sources: d.arrayOf(d.oneOfType([d.exact({
    media: d.string.isRequired,
    type: d.string,
    sizes: d.string,
    srcSet: d.string.isRequired
  }), d.exact({
    media: d.string,
    type: d.string.isRequired,
    sizes: d.string,
    srcSet: d.string.isRequired
  })]))
};
const B = ["fallback"],
  F = function (t) {
    let {
        fallback: a
      } = t,
      i = c(t, B);
    return a ? e.createElement(G, u({}, i, {
      fallback: {
        src: a
      },
      "aria-hidden": !0,
      alt: ""
    })) : e.createElement("div", u({}, i));
  };
F.displayName = "Placeholder", F.propTypes = {
  fallback: d.string,
  sources: null == (V = G.propTypes) ? void 0 : V.sources,
  alt: function (e, t, a) {
    return e[t] ? new Error("Invalid prop `".concat(t, "` supplied to `").concat(a, "`. Validation failed.")) : null;
  }
};
const U = function (t) {
  return e.createElement(e.Fragment, null, e.createElement(G, u({}, t)), e.createElement("noscript", null, e.createElement(G, u({}, t, {
    shouldLoad: !0
  }))));
};
U.displayName = "MainImage", U.propTypes = G.propTypes;
const Y = function (e, t, a) {
    for (var _len = arguments.length, i = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      i[_key - 3] = arguments[_key];
    }
    return e.alt || "" === e.alt ? h.string(e, t, a, ...i) : new Error("The \"alt\" prop is required in ".concat(a, ". If the image is purely presentational then pass an empty string: e.g. alt=\"\". Learn more: https://a11y-style-guide.com/style-guide/section-media.html"));
  },
  X = {
    image: h.object.isRequired,
    alt: Y
  },
  J = ["as", "image", "style", "backgroundColor", "className", "class", "onStartLoad", "onLoad", "onError"],
  Z = ["style", "className"],
  K = new Set();
let Q, ee;
const te = function (e) {
    let {
        as: t = "div",
        image: a,
        style: l,
        backgroundColor: d,
        className: h,
        class: g,
        onStartLoad: p,
        onLoad: m,
        onError: f
      } = e,
      w = c(e, J);
    const {
        width: y,
        height: b,
        layout: v
      } = a,
      E = function (e, t, a) {
        const i = {};
        let r = "gatsby-image-wrapper";
        return L() || (i.position = "relative", i.overflow = "hidden"), "fixed" === a ? (i.width = e, i.height = t) : "constrained" === a && (L() || (i.display = "inline-block", i.verticalAlign = "top"), r = "gatsby-image-wrapper gatsby-image-wrapper-constrained"), {
          className: r,
          "data-gatsby-image-wrapper": "",
          style: i
        };
      }(y, b, v),
      {
        style: M,
        className: k
      } = E,
      S = c(E, Z),
      $ = r(),
      I = n(() => JSON.stringify(a.images), [a.images]);
    g && (h = g);
    const x = function (e, t, a) {
      let i = "";
      return "fullWidth" === e && (i = "<div aria-hidden=\"true\" style=\"padding-top: ".concat(a / t * 100, "%;\"></div>")), "constrained" === e && (i = "<div style=\"max-width: ".concat(t, "px; display: block;\"><img alt=\"\" role=\"presentation\" aria-hidden=\"true\" src=\"data:image/svg+xml;charset=utf-8,%3Csvg height='").concat(a, "' width='").concat(t, "' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3C/svg%3E\" style=\"max-width: 100%; display: block; position: static;\"></div>")), i;
    }(v, y, b);
    return s(() => {
      Q || (Q = import("./lazy-hydrate-5dfb5ec5.js").then(_ref7 => {
        let {
          renderImageToString: e,
          swapPlaceholderImage: t
        } = _ref7;
        return ee = e, {
          renderImageToString: e,
          swapPlaceholderImage: t
        };
      }));
      const e = $.current.querySelector("[data-gatsby-image-ssr]");
      if (e && N()) return e.complete ? (null == p || p({
        wasCached: !0
      }), null == m || m({
        wasCached: !0
      }), setTimeout(() => {
        e.removeAttribute("data-gatsby-image-ssr");
      }, 0)) : (null == p || p({
        wasCached: !0
      }), e.addEventListener("load", function t() {
        e.removeEventListener("load", t), null == m || m({
          wasCached: !0
        }), setTimeout(() => {
          e.removeAttribute("data-gatsby-image-ssr");
        }, 0);
      })), void K.add(I);
      if (ee && K.has(I)) return;
      let t, i;
      return Q.then(_ref8 => {
        let {
          renderImageToString: e,
          swapPlaceholderImage: r
        } = _ref8;
        $.current && ($.current.innerHTML = e(u({
          isLoading: !0,
          isLoaded: K.has(I),
          image: a
        }, w)), K.has(I) || (t = requestAnimationFrame(() => {
          $.current && (i = r($.current, I, K, l, p, m, f));
        })));
      }), () => {
        t && cancelAnimationFrame(t), i && i();
      };
    }, [a]), o(() => {
      K.has(I) && ee && ($.current.innerHTML = ee(u({
        isLoading: K.has(I),
        isLoaded: K.has(I),
        image: a
      }, w)), null == p || p({
        wasCached: !0
      }), null == m || m({
        wasCached: !0
      }));
    }, [a]), i(t, u({}, S, {
      style: u({}, M, l, {
        backgroundColor: d
      }),
      className: "".concat(k).concat(h ? " ".concat(h) : ""),
      ref: $,
      dangerouslySetInnerHTML: {
        __html: x
      },
      suppressHydrationWarning: !0
    }));
  },
  ae = a(function (e) {
    return e.image ? (L() || "development" !== process.env.NODE_ENV || console.warn('[gatsby-plugin-image] You\'re missing out on some cool performance features. Please add "gatsby-plugin-image" to your gatsby-config.js'), i(te, e)) : ("development" === process.env.NODE_ENV && console.warn("[gatsby-plugin-image] Missing image prop"), null);
  });
ae.propTypes = X, ae.displayName = "GatsbyImage";
const ie = ["src", "__imageData", "__error", "width", "height", "aspectRatio", "tracedSVGOptions", "placeholder", "formats", "quality", "transformOptions", "jpgOptions", "pngOptions", "webpOptions", "avifOptions", "blurredOptions", "breakpoints", "outputPixelDensities"],
  re = function (e, t) {
    for (var _len2 = arguments.length, a = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      a[_key2 - 2] = arguments[_key2];
    }
    return "fullWidth" !== e.layout || "width" !== t && "height" !== t || !e[t] ? h.number(e, t, ...a) : new Error("\"".concat(t, "\" ").concat(e[t], " may not be passed when layout is fullWidth."));
  },
  ne = new Set(["fixed", "fullWidth", "constrained"]),
  se = {
    src: h.string.isRequired,
    alt: Y,
    width: re,
    height: re,
    sizes: h.string,
    layout: e => {
      if (void 0 !== e.layout && !ne.has(e.layout)) return new Error("Invalid value ".concat(e.layout, "\" provided for prop \"layout\". Defaulting to \"constrained\". Valid values are \"fixed\", \"fullWidth\" or \"constrained\"."));
    }
  },
  oe = function (t) {
    return function (a) {
      let {
          src: i,
          __imageData: r,
          __error: n
        } = a,
        s = c(a, ie);
      return n && console.warn(n), r ? e.createElement(t, u({
        image: r
      }, s)) : (console.warn("Image not loaded", i), n || "development" !== process.env.NODE_ENV || console.warn('Please ensure that "gatsby-plugin-image" is included in the plugins array in gatsby-config.js, and that your version of gatsby is at least 2.24.78'), null);
    };
  }(ae);
oe.displayName = "StaticImage", oe.propTypes = se;
export { ae as G, A as L, U as M, F as P, oe as S, c as _, u as a, j as b, W as c, T as d, R as e, _ as f, O as g, N as h, M as i, E as j, C as w };